import mitt from "mitt"

export default {
  install: (app) => {
    const emitter = mitt()  // Simples emissor de eventos produtor-consumidor
    app.config.globalProperties.$eventBus = emitter  // Permite acesso via $this.eventBus com Options API
    app.provide("eventBus", emitter)  // Permite acesso via inject("eventBus") com Composition API
  }
}